import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationService } from 'app/modules/configuration/configuration.service';

@Component({
  selector: 'app-integration-settings',
  templateUrl: './integration-settings.component.html',
  styles: [
  ]
})
export class IntegrationSettingsComponent implements OnInit {
  @Input() content: any;
  integrationSettingsForm: FormGroup;
  loader = false;
  submitted = false;
  statusEnabled: boolean
  statusMsg = ''
  integrationData:any
  errorMessage = ''
  verified: boolean
  getformData:any

  constructor(public dialogRef: NgbActiveModal, public fb: FormBuilder, public configService: ConfigurationService,) { }

  ngOnInit(): void {
   console.log(this.content)
   this.getformData = this.content.data
   console.log(this.getformData)
    this.integrationSettingsForm = this.fb.group({
      accesstoken: [this.getformData? this.getformData['accessToken']:'', [Validators.required]],
      restaurantsid: [this.getformData? this.getformData['restID']:'', [Validators.required]],
      apikey: [this.getformData? this.getformData['appKey']:'', [Validators.required]],
      apisecretkey: [this.getformData? this.getformData['appSecret']:'', [Validators.required]],
      status: [this.getformData? this.getformData['verified']:'', [Validators.required]],
    });
    this.verified = this.getformData['verified']
  }
  

  get f() {
    return this.integrationSettingsForm.controls;
  }

  statusEnable(event: any) {
    // this.statusEnabled = false
    console.log(event.target.checked)
    if (event.target.checked) {
      this.statusEnabled = event.target.checked
    }
  }

  confirm() {
    this.submitted = true;
    if (this.integrationSettingsForm.invalid) {
      console.log("check")
      return;
    } 
    const data = {
      appKey : this.integrationSettingsForm.value["apikey"],
      appSecret : this.integrationSettingsForm.value["apisecretkey"],
      accessToken : this.integrationSettingsForm.value["accesstoken"],
      restID : this.integrationSettingsForm.value["restaurantsid"],
      status: this.integrationSettingsForm.value["status"]
    }
    console.log(data)
    this.loader = true
    this.configService
    .validatePetPoojaDetails(data)
    .then((response) => {
      console.log(response)
      this.loader = false;
      console.log("check")
       this.integrationData = response
       if(response['status'] = 1) {
        data["verified"] = true
        this.verified = true
        setTimeout(() => {
          this.dialogRef.close({
            success: { result: true, data: this.integrationData , formData:data},
          });
        }, 2000);
       } else {
        this.verified = false
       }
       console.log(this.verified)
    })
    .catch((err) => {
      console.log(err)
      this.loader = false;
      this.verified = false
      this.errorMessage = "Sorry!! Invalid data, Unable to update Petpooja Integration";
      console.log(this.errorMessage)
    });
  }

  close() {
    this.dialogRef.close({ success: false });
  }

}
